import * as calendarRepository from '../Repository/CalendarRepository';

export async function getCalendarContent(emailId, conversationId) {
  const [sandboxEmailResponse, inviteDataResponse] = await Promise.all([
    calendarRepository.getCalendarSandboxEmail(emailId),
    calendarRepository.getCalendarInviteData(conversationId),
  ]);

  return {
    sandboxEmail: sandboxEmailResponse.data,
    inviteData: inviteDataResponse.data,
  };
}
